import React, { useState, forwardRef, useImperativeHandle } from "react";
import { apiFetch } from "../../lib/api";

const PasteDiscogsBatch = forwardRef(({ onListingsFetched }, ref) => {
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Expose clearInput method to parent
  useImperativeHandle(ref, () => ({
    clearInput: () => setInput(""),
  }));

  const extractReleaseIds = (text) => {
    const lines = text
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    return lines
      .map((line) => {
        const match = line.match(/\/release\/(\d+)/);
        return match ? match[1] : null;
      })
      .filter(Boolean);
  };

  const handleFetch = async () => {
    setLoading(true);
    setError(null);

    const releaseIds = extractReleaseIds(input);

    if (releaseIds.length === 0) {
      setError("Please enter at least one valid Discogs release URL.");
      setLoading(false);
      return;
    }

    try {
      const res = await apiFetch("/api/discogs/fetch-batch", {
        method: "POST",
        body: JSON.stringify({ releaseIds }),
      });

      const data = await res.json();

      if (res.ok && data.results) {
        onListingsFetched(data.results);
      } else {
        console.error("Backend error:", data);
        setError("❌ Failed to fetch one or more releases.");
      }
    } catch (err) {
      console.error("Network error:", err);
      setError("🔥 Network error trying to reach backend.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-white">
      <label className="block font-semibold mb-2 text-zinc-300">
        Paste Discogs URLs (one per line)
      </label>
      <textarea
        rows={6}
        className="w-full p-4 border border-zinc-700 rounded-lg bg-black text-white font-mono placeholder-zinc-500"
        placeholder={`https://www.discogs.com/release/123456...\nhttps://www.discogs.com/release/234567...`}
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <button
        className="mt-4 px-6 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg shadow-md transition"
        onClick={handleFetch}
        disabled={loading}
      >
        {loading ? "Fetching..." : "Fetch Listings"}
      </button>

      {error && <div className="text-red-400 mt-3">{error}</div>}
    </div>
  );
});

export default PasteDiscogsBatch;
